import { useFormikContext } from "formik";
import React from "react";
import { PriceDecreasePolicy, PriceIncreasePolicy, TravelerPreference } from "types";
import { RadioInput } from "@/components/Common/RadioInput";

export const PriceChangePolicyField = () => {
    const { values, setFieldValue } = useFormikContext<TravelerPreference>();
    const policy = values.reschedule?.priceChangePolicy;

    if (!policy) {
        return null;
    }

    return (
        <div className="space-y-4 pb-4 pt-3">
            <div>
                <p className="mb-2 font-semibold">Price Increase Policy</p>
                <div className="space-y-2">
                    <RadioInput
                        name="priceIncreasePolicy"
                        value={PriceIncreasePolicy.PAYMENT_BEFORE_MODIFICATION}
                        checked={policy.priceIncreasePolicy === PriceIncreasePolicy.PAYMENT_BEFORE_MODIFICATION}
                        onChange={() =>
                            setFieldValue(
                                "reschedule.priceChangePolicy.priceIncreasePolicy",
                                PriceIncreasePolicy.PAYMENT_BEFORE_MODIFICATION,
                            )
                        }
                    >
                        Collect payment prior to committing modification
                    </RadioInput>
                    <RadioInput
                        name="priceIncreasePolicy"
                        value={PriceIncreasePolicy.PAYMENT_AFTER_MODIFICATION}
                        checked={policy.priceIncreasePolicy === PriceIncreasePolicy.PAYMENT_AFTER_MODIFICATION}
                        onChange={() =>
                            setFieldValue(
                                "reschedule.priceChangePolicy.priceIncreasePolicy",
                                PriceIncreasePolicy.PAYMENT_AFTER_MODIFICATION,
                            )
                        }
                    >
                        Prompt for payment after committing modification (payment not enforced)
                    </RadioInput>
                </div>
            </div>
            <div>
                <p className="mb-2 font-semibold ">Price Decrease Policy</p>
                <div className="space-y-2">
                    <RadioInput
                        name="priceDecreasePolicy"
                        value={PriceDecreasePolicy.REFUND_DELTA}
                        checked={policy.priceDecreasePolicy === PriceDecreasePolicy.REFUND_DELTA}
                        onChange={() =>
                            setFieldValue(
                                "reschedule.priceChangePolicy.priceDecreasePolicy",
                                PriceDecreasePolicy.REFUND_DELTA,
                            )
                        }
                    >
                        Issue a refund for the difference
                    </RadioInput>
                    <RadioInput
                        name="priceDecreasePolicy"
                        value={PriceDecreasePolicy.RETAIN_PRICE}
                        checked={policy.priceDecreasePolicy === PriceDecreasePolicy.RETAIN_PRICE}
                        onChange={() =>
                            setFieldValue(
                                "reschedule.priceChangePolicy.priceDecreasePolicy",
                                PriceDecreasePolicy.RETAIN_PRICE,
                            )
                        }
                    >
                        Do not offer a refund (retain original price)
                    </RadioInput>
                </div>
            </div>
        </div>
    );
};
